import axios from "axios";

export const AxiosConnect = axios.create({
    baseURL:  "https://axgura-dashboard.uk.r.appspot.com" || "http://localhost:5001"
});
